
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.cartToken = null;
    this.lineItems = [];

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );

    this.bindUIElements();

    this.setHeaderCartIconAccessibility();
    this.setHeaderCartIconsAccessibility();
    toggleProgressBarVisibilityOnUpdate();

    this.initCartSession();
  }

  isReturningFromCheckout() {
    const referrer = document.referrer || '';
    return /\/checkouts?\//.test(referrer) || referrer.includes('checkout.shopify.com');
  }

  async clearCheckoutDiscounts() {
    let cart;

    try {
      cart = await fetch(window.Shopify.routes.root + 'cart.js').then((response) => response.json());
    } catch (err) {
      console.error('cdebug clearCheckoutDiscounts cart fetch error', err);
      return;
    }

    const hasDiscount =
      (Array.isArray(cart.cart_level_discount_applications) &&
        cart.cart_level_discount_applications.length > 0) ||
      (Array.isArray(cart.discount_codes) && cart.discount_codes.length > 0);

    if (!hasDiscount) return;

    const sections = this.getSectionsToRender().map((section) => section.id);

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          discount: '',
          sections,
          sections_url: window.location.pathname,
        }),
      });

      if (!response.ok) return;

      const parsedState = await response.json();
      const subtotalBeforeDiscount = Array.isArray(parsedState.items)
        ? parsedState.items.reduce(
            (sum, item) => sum + (item.original_line_price || item.line_price || 0),
            0
          )
        : parsedState.original_total_price;

      if (subtotalBeforeDiscount > 0) {
        this.dataset.cartOriginalTotal = String(subtotalBeforeDiscount);
        this.dataset.customTotal = String(subtotalBeforeDiscount);
      }

      if (parsedState.total_price != null) {
        this.dataset.cartTotal = String(parsedState.total_price);
      }

      this.renderContents(parsedState, false, 'checkout-return');
    } catch (err) {
      console.error('cdebug clearCheckoutDiscounts update error', err);
    }
  }

  async initCartSession() {
    // On page load, we need to make sure that the cart token gets properly loaded first before getting cart line ids
    await this.getCartToken();

    const returningFromCheckout =
      sessionStorage.getItem('openCartDrawer') === 'true' || this.isReturningFromCheckout();

    if (returningFromCheckout) {
      await this.clearCheckoutDiscounts();
    }

    this.getCartLineIds();
  }

  bindUIElements() {
    this.purchaseOptions = this.querySelector('#selling-plan-options');

    if(this.purchaseOptions) {
      this.purchaseOptions.removeEventListener('change', this.onSubscriptionChanged.bind(this));

      this.purchaseOptions.addEventListener('change', this.onSubscriptionChanged.bind(this))
    }
  }

  showCartDrawerLoader() {
    const cartDrawerLoader = this.querySelector('.cart-drawer-loader');
    if (!cartDrawerLoader) return;

    cartDrawerLoader.classList.remove('hidden');
    this.querySelector('.drawer__inner')?.setAttribute('aria-busy', 'true');
  }

  hideCartDrawerLoader() {
    const cartDrawerLoader = this.querySelector('.cart-drawer-loader');
    if (!cartDrawerLoader) return;

    cartDrawerLoader.classList.add('hidden');
    this.querySelector('.drawer__inner')?.removeAttribute('aria-busy');
  }

  toggleCartDrawerLoader() {
    const cartDrawerLoader = this.querySelector('.cart-drawer-loader');
    if (!cartDrawerLoader) return;

    if (cartDrawerLoader.classList.contains('hidden')) {
      this.showCartDrawerLoader();
    } else {
      this.hideCartDrawerLoader();
    }
  }

  async onSubscriptionChanged(e) {
    let response;
    const selectedValue = e.target.value;
  
    /*this.toggleCartDrawerLoader();
     // Look for selling plans
    const mealLineItems = Array.from(this.querySelectorAll('.cart-item.--item-is-meal'));

    let mealPlanLinesForUpdate = mealLineItems.map((mealLineItem) => {
      const mealLineItemId = mealLineItem.getAttribute('data-line-id');
      const sellingPlanDOM = mealLineItem.querySelector(`option[data-selling-plan-name="${selectedValue}"]`)
      const sellingPlanId = sellingPlanDOM?.value;
      console.log("!! Selling plan id", sellingPlanId)

      return {
        lineId: mealLineItemId,
        sellingPlanId: sellingPlanId
      }
    });*/
    const normalize = (value) => (value || '').toLowerCase().trim();
    const selected = normalize(selectedValue);
  
    this.showCartDrawerLoader();
     // Look for selling plans
    const mealLineItems = Array.from(this.querySelectorAll('.cart-item.--item-is-meal'));

    let mealPlanLinesForUpdate = mealLineItems.map((mealLineItem) => {
      const mealLineItemId = mealLineItem.getAttribute('data-line-id');
      const options = Array.from(mealLineItem.querySelectorAll('.selling-plan-options option'));
      const sellingPlanDOM = options.find(
        (opt) => normalize(opt?.dataset?.sellingPlanName) === selected
      );
      const sellingPlanId = sellingPlanDOM?.value;
      console.log("!! Selling plan id", sellingPlanId)

      return {
        lineId: mealLineItemId,
        sellingPlanId: sellingPlanId
      }
    }).filter((line) => line.lineId);
  
  
    console.log('cdebug selectedValue and mealPlanLinesForUpdate', selectedValue, mealPlanLinesForUpdate);
  
    const cartMutation = `mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
      cartLinesUpdate(cartId: $cartId, lines: $lines) {
        cart {
          id
        }
        userErrors {
          field
          message
        }
      }
    }`;
  
    const mutationVariables = {
      cartId: `gid://shopify/Cart/${this.cartToken}`,
      lines: mealPlanLinesForUpdate.map((line) => ({
        id: line.lineId,
        sellingPlanId: line.sellingPlanId
          ? `gid://shopify/SellingPlan/${line.sellingPlanId}`
          : null
      }))
    };
  
    try {
      response = await window.storeFrontAPIClient.request(cartMutation, {
        variables: mutationVariables
      });
    } catch (err) {
      console.error('cdebug error', err);
    } finally {
      this.hideCartDrawerLoader();
    }
  
    console.log('cdebug cart gql', response);
  
    if (response?.data?.cartLinesUpdate?.cart?.id) {
      console.log('cdebug successful updating of selling plan');
      this.refreshCart();
    } else {
      console.warn('cdebug failed to update cart lines');
      // Optional: handle fallback logic here
    }
  }

  async getCartToken() {
    let response;
    let responseStatus;

    try {
      response = await fetch(window.Shopify.routes.root + `cart.js`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        responseStatus = response.status;

        console.log('cdebug', response)

        return response.json();
      });

    } catch(e) {
      console.error('cdebug error', e);
      console.log('cdebug error details', e);
    }


    // If response is 200, then successful request
    if(responseStatus == 200) {
      this.cartToken = response?.token;
    } else {
      // If no cart token, we cannot allow switching of cart attributes
    }

    console.log('cdebug cart response', response)
    console.log('cdebug cart token', this.cartToken)
  }

  async getCartLineIds() {
    let response;
    let responseStatus;

    let cartQuery = `query getCartGQL($id: ID!) {
      cart(id: $id) {
        id
        lines(first: 250) {
          edges {
            node {
              id
              quantity
              merchandise {
                ... on ProductVariant {
                  id
                  product {
                    title
                  }
                  title
                }
              }
              attributes {
                key
                value
              }
            }
          }
        }
      }
    }`;

    try {
      response = await window.storeFrontAPIClient.request(cartQuery, {
        variables: {
          id: `gid://shopify/Cart/${this.cartToken}`
        }
      });

    } catch(e) {
      console.error('cdebug error', e);
      console.log('cdebug error details', e);
    }

    console.log('cdebug cart gql', response);

    // If response is 200, then successful request
    if(Array.isArray(response?.data?.cart?.lines?.edges)) {
      this.formatAndSaveLineIds(response?.data?.cart?.lines?.edges);
      this.printLineIdsToDOM();
    } else {
      // If failed, do something as a fallback
    }
  }

  async refreshCart() {

    let response;
    let responseStatus;

    try {
      response = await fetch(window.Shopify.routes.root + `?sections=cart-drawer`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        responseStatus = response.status;

        return response.json();
      });

    } catch(e) {
      console.error('cdebug error', e);
      console.log('cdebug error details', e);
    }


    // If response is 200, then successful request
    if(responseStatus == 200) {

        [{
          id: "cart-drawer",
          selector: "#CartDrawer",
        }].forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);

        sectionElement.innerHTML = this.getSectionInnerHTML(
          response[section.id],
          section.selector
        );

      });

    } else {
      // If no cart token, we cannot allow switching of cart attributes
    }


    this.getCartLineIds();
    this.bindUIElements();

    console.log('cdebug cart response', new DOMParser()
    .parseFromString(response['cart-drawer'], "text/html").querySelector('.cart-items'))
  }

  printLineIdsToDOM() {
    var lineItemsDOM = Array.from(this.querySelectorAll('.cart-item'));

    lineItemsDOM.forEach((lineItemDOM) => {
      const lineItemDOMVariant = lineItemDOM.getAttribute('data-line-variant-id');
      const lineItem = this.lineItems.find((lineItem) => lineItem.variantId == lineItemDOMVariant);

      console.log('cdebug lineItem', lineItemDOM, lineItem)

      if(lineItem) {
        lineItemDOM.setAttribute('data-line-id', lineItem.id);
      }

    })
  }

  formatAndSaveLineIds(lineItems) {
    this.lineItems = lineItems.map((item) => {
      let lineItem = item.node;
      let variantId = lineItem?.merchandise?.id?.replace("gid://shopify/ProductVariant/", "");

      return {
        id: lineItem.id,
        variantId: variantId
      }
    });;

    hideBoosterItems();
    console.log('cdebug lineitems', this.lineItems);
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");

    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
      // cart-note function : refer cart-drawer.liquid
      addCartNote && addCartNote();
    });

    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
        // cart-note function : refer cart-drawer.liquid
        addCartNote && addCartNote();
      }
    });
  }


  setHeaderCartIconsAccessibility() {
    const cartLinks = Array.from(document.querySelectorAll(".cart-icon-bubble"));

    cartLinks.forEach((cartLink) => {
      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");
      cartLink.addEventListener("click", (event) => {
        event.preventDefault();
        this.open(cartLink);
        // cart-note function : refer cart-drawer.liquid
        addCartNote && addCartNote();
      });
      cartLink.addEventListener("keydown", (event) => {
        if (event.code.toUpperCase() === "SPACE") {
          event.preventDefault();
          this.open(cartLink);
          // cart-note function : refer cart-drawer.liquid
          addCartNote && addCartNote();
        }
      });
    })

    window.initCollectionProgess && window.initCollectionProgess();
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");

        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");

        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    // removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState, showToastInstead, source) {
    console.log('cdebug renderContents', this, parsedState)

    // TO FIX. Why parsedState is sometimes quantity and sometimes item_count
    let quantity = parsedState.quantity || parsedState?.['item_count'];

    if(quantity == 0) {
      this?.classList.add("is-empty");
      this.querySelector(".drawer__inner").classList.add("is-empty");
    } else {
      this?.classList.contains("is-empty") &&
      this?.classList.remove("is-empty");

      this.querySelector(".drawer__inner").classList.contains("is-empty") &&
        this.querySelector(".drawer__inner").classList.remove("is-empty");
    }

    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement || !parsedState?.sections?.[section.id]) return;

      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );

    });

    // Update cart links after adding to cart
    const cartIconBubble = document.querySelector("#cart-icon-bubble");
    const cartLinks = Array.from(document.querySelectorAll(".cart-icon-bubble"))

    if (cartIconBubble) {
      cartLinks.forEach((cartLink) => {
        cartLink.innerHTML = cartIconBubble.innerHTML;
      });
    }

    window.initCollectionProgess && window.initCollectionProgess();

    const toastMessage = window?.variantStrings?.addToCartToast.replace('[product-name]', parsedState.title);

    const toastConfig = {
      text: toastMessage,
      duration: 5000,
      // duration: -1,
      newWindow: true,
      close: true,
      gravity: "top", // `top` or `bottom`
      position: "left", // `left`, `center` or `right`
      stopOnFocus: true, // Prevents dismissing of toast on hover
      style: {
        background: "rgba(var(--color-button),var(--alpha-button-background))",
      },
      onClick: function(){} // Callback after click
    };

    const collectionProgressBar = document.querySelector('.collection-progress-bar');

    console.log('cdebug parsedState.quantity', parsedState);


    if(quantity > 0) {
      collectionProgressBar && collectionProgressBar.classList.add('--active');

      // Get again cart token to make sure we have the latest cart token
      this.getCartToken();
      // Update line ids
      this.getCartLineIds();
    } else {
      collectionProgressBar && collectionProgressBar.classList.remove('--active');
    }

    toggleProgressBarVisibilityOnUpdate();

    // Don't open the cart drawer on add-to-cart; quantity sync also re-renders quietly.
    // Show a toast when available (cre-product-form / product-form pass showToastInstead).
    if (source != 'cre-quantity-sync' && showToastInstead && typeof Toastify === 'function') {
      if (window.prevToast && window.prevToast.hideToast) {
        window.prevToast.hideToast();
      }

      window.prevToast = Toastify(toastConfig);
      window.prevToast.showToast();
    }


    this.bindUIElements();
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    const parsed = new DOMParser().parseFromString(html, "text/html");
    const sectionNode = parsed.querySelector(selector);
    return sectionNode ? sectionNode.innerHTML : "";
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

class ClearCart extends HTMLElement {
  constructor() {
    super();

    // Find the button and attach the click event listener
    this.clearButton = this.querySelector("button");
    if (this.clearButton) {
      this.clearButton.addEventListener(
        "click",
        this.onClickClearCart.bind(this)
      );
    }
  }

  onClickClearCart(event) {
    event.preventDefault();

    const cartDrawer = document.querySelector('cart-drawer');
    cartDrawer?.showCartDrawerLoader();

    // Handling the click event
    const url = "/cart/clear.js";
    const data = {
      sections: document.querySelector("cart-drawer-items").getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    };

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };


    fetch(url, options)
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        document.querySelector("cart-drawer-items").getSectionsToRender().forEach((section) => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = document.querySelector("cart-drawer-items").getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );


        });


        // Hide progress bar upon clearing cart
        const collectionProgressBar = document.querySelector('.collection-progress-bar');
        if(collectionProgressBar) {
          collectionProgressBar.classList.remove('--active');
        }
        toggleProgressBarVisibilityOnUpdate();


        // Update items
        publish(PUB_SUB_EVENTS.cartUpdate,
          {
            source: 'clear-cart',
            productVariantId: null,
            sectionUpdates: [],
            incomingQty: 0,
          });

        // Ensure product cards revert Add to Cart (qty map may have been stale during early handlers)
        if (typeof window.syncAllCartControlVisibility === 'function') {
          window.syncAllCartControlVisibility();
        }

        if(document.querySelector('cre-price-sync') && document.querySelector('cre-price-sync')?.syncPriceToProduct) {
          document.querySelector('cre-price-sync')?.syncPriceToProduct()
        }

        document.querySelector("cart-drawer").classList.add("is-empty");
        // Get all the product cards from the current page
        const quantityInputs = document.querySelectorAll(
          "quantity-input:not(cart-drawer .quantity-input)"
        );
        // Filter the product cards which are already added to the cart
        const visibleQuantityInputs = Array.from(quantityInputs).filter(
          (input) => !input.classList.contains("hidden")
        );

        if (visibleQuantityInputs.length === 0) return;

        visibleQuantityInputs.forEach((each) => {
          const removedProductVariantId = each.dataset.vid;
          const productremove = new CustomEvent(`remove-product--${removedProductVariantId}`, {
            detail: { quantity: 0 }
          })
          document.dispatchEvent(productremove)
        });

        const cartLinks = Array.from(document.querySelectorAll(".cart-icon-bubble"))

        cartLinks.forEach((cartLink) => {
          cartLink.innerHTML = document.querySelector("#cart-icon-bubble").innerHTML;
        });

        window.initCollectionProgess && window.initCollectionProgess();
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally(() => {
        cartDrawer?.hideCartDrawerLoader();
      });
  }
}


function toggleProgressBarVisibilityOnUpdate() {

  const mealItems = Array.from(document.querySelectorAll('.cart-item.--item-is-meal'));
  const cartDrawerFooter = document.querySelector('.cart-drawer__footer');
  const collectionBarWrapper = document.querySelector('.collection-bar-wrapper');

  if(mealItems.length > 0) {
    if(cartDrawerFooter) {
      cartDrawerFooter.classList.add('--active');
    }

    if(collectionBarWrapper) {
      collectionBarWrapper.classList.add('--active');
    }

  } else {

    if(cartDrawerFooter) {
      cartDrawerFooter.classList.remove('--active');
    }

    if(collectionBarWrapper) {
      collectionBarWrapper.classList.remove('--active');
    }

  }

}

customElements.define("clear-cart", ClearCart);
